<script setup>
import { ref } from 'vue'

const array = window.blockInfoIsConfirmArround

const activeIndex = ref(null);

function setActive(index) {
   activeIndex.value = index;
}

</script>

<template>
   <div class="subcomments_arround">
      <button type="button" class="subcomments_button subcomments_button--add" v-for="(item, index) in array"
         :key="index" :class="{ 'subcomments_button--active': index === activeIndex }" @click="setActive(index)">
         {{ item.title }}
      </button>
   </div>
</template>

<style lang="scss">
.subcomments_arround {
   display: flex;
   gap: 12px;
   margin: 0 24px;
   // flex-wrap: wrap;
}

.subcomments_button--add {
   // background-color: #fff;
   border: 1px rgb(218, 220, 224) solid;
   border-radius: 80px;
   box-sizing: border-box;
   cursor: pointer;
   display: inline-block;
   font-family: "Google Sans", Roboto, Arial, sans-serif;
   font-size: 14px;
   font-weight: 600;
   height: 28px;
   letter-spacing: 0.25px;
   line-height: 18px;
   min-width: auto;
   z-index: 10;
   font-size: calc(0.825rem * var(--app-font-size));
}

.subcomments_button--active {
   color: #056449 !important;
   background-color: #e6f3ef !important;
   border-color: #00000000 !important;
}

.subcomments_button {
   color: var(--data_color_additional_text);
   padding: 0px 14px;
   // border-radius: 8px;
   border-radius: 10px;
   border: 1px solid  var(--data_subcomments_button);
   // border: 1px solid rgb(218, 220, 224);
   white-space: nowrap;
}
</style>
